export default __webpack_public_path__ + "static/media/Ts_2020-7-1.dfcaf74f.png";